import { Transition } from "../../../core/flows/Transition";
import { AddOnsContext } from "../../Addons/Context/AddOnsContext";
import { MainBookingContext } from "../../MainBookingFlow/Context/MainBookingContext";
import { TopBarContext } from "../../TopBar/Context/TopBarContext";
import { TicketOptionContext } from "../../TrainOfferPage/TicketOptionFlow/Context/TicketOptionContext";
import { CheckoutContext } from "../Context/CheckoutContext";
import { PassengerDetailsContext } from "../PassengerDetailsFlow/Context/PassengerDetailsContext";
import { PaymentContext } from "../Payment/Context/PaymentContext";
import { SeatingMapContext } from "../SeatingMap/Context/SeatingMapContext";
import { VoucherContext } from "../Voucher/Context/VoucherContext";

export class CheckoutTransition extends Transition {
    constructor(entryStep: string, exitSteps: string[]) {
        super(entryStep, exitSteps);
    }

    onExecute(): string[] {

        const context = this.getCtx<CheckoutContext>("checkoutContext", this.entryStep);

        if (!context) {
            console.log("[Transition] No choice data available, using default exits");
            return this.exitSteps;
        }

        const passengerDetailsContext = new PassengerDetailsContext()
        this.setCtx<PassengerDetailsContext>("passengerDetailsContext", passengerDetailsContext, this.entryStep)

        const voucherContext = new VoucherContext()
        this.setCtx<VoucherContext>("voucherContext", voucherContext, this.entryStep)

        const paymentContext = new PaymentContext()
        this.setCtx<PaymentContext>("paymentContext", paymentContext, this.entryStep)

        const seatingMapContext = new SeatingMapContext()
        this.setCtx<SeatingMapContext>("seatingMapContext", seatingMapContext, this.entryStep)

        const addonsContext = new AddOnsContext()
        this.setCtx<AddOnsContext>("addonsContext", addonsContext, this.entryStep)

        if (!(context.routeTo ?? []).every(step => this.exitSteps.includes(step))) {
            console.log(`[Transition] Invalid choice: ${this.getCtx("choice")}`);
            return [];
        }

        return [...(context?.routeTo ?? [])]
    }

}